// BackButton.js
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import '../styles/backButton.css';

const BackButton = ({ showOn = [], hideOn = ['/'] }) => {
  const [isVisible, setIsVisible] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Check if we should show the button on this page
    const currentPath = location.pathname;
    
    // Hide on home page by default
    if (hideOn.includes(currentPath)) {
      setIsVisible(false);
      return;
    }

    // Show on specific pages if specified
    if (showOn.length > 0) {
      const shouldShow = showOn.some(path => currentPath.includes(path));
      setIsVisible(shouldShow);
    } else {
      // Show on all pages except hideOn pages
      setIsVisible(true);
    }
  }, [location, showOn, hideOn]);

  const handleGoBack = () => {
    // Check if there's history to go back to
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      // Fallback to home if no history
      navigate('/');
    }
  };

  if (!isVisible) return null;

  return (
    <button 
      className="floating-back-button"
      onClick={handleGoBack}
      aria-label="Go back to previous page"
    >
      <svg 
        width="24" 
        height="24" 
        viewBox="0 0 24 24" 
        fill="none" 
        stroke="currentColor" 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      >
        <path d="M19 12H5M12 19l-7-7 7-7" />
      </svg>
      <span className="back-text">Back</span>
    </button>
  );
};

export default BackButton;